import { LicenseManager, provideGlobalGridOptions } from 'ag-grid-enterprise';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { DomainType, DomainUtility } from '@jms/model';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;
import { UtilService } from '@jms/utils/util.services';

// Side-effect import: each portal runtime registers the shared, domain-resolved entity catalog.
import '@workbuddy/entities/entity.manifests';

navigator.serviceWorker.register('/download-zip/files.zip.worker.js', { scope: '/download-zip/' });

LicenseManager.setLicenseKey(ConfigService?.environment?.grid);
provideGlobalGridOptions({ theme: "legacy" });

if (ConfigService.environment.production) {
    enableProdMode();
}

const domain = UtilService.getLocation().hostName;

switch (DomainUtility.getDomainType(domain)) {

    case DomainType.TrackingPortal: {
        import('./app/application.tracking.module').then(m => {
            platformBrowserDynamic().bootstrapModule(m.ApplicationTrackingModule);
        });
        break;
    }

    default: {
        import('./app/application.module').then(m => {
            platformBrowserDynamic().bootstrapModule(m.ApplicationModule);
        });
        break;
    }

}
